import { useState } from 'react';
import { CHDOAllApplications } from '@/features/ApplicationForm/FormConfig/CHDO/CHDODashboard/CHDOAllApplications';
import { CHDOApprovedApplications } from '@/features/ApplicationForm/FormConfig/CHDO/CHDODashboard/CHDOApprovedApplications';

interface IApplicationDashboardComponentProps {
  data: any;
  defaultView?: 'ALL' | 'APPROVED';
}

export const CHDODashboard = ({ data, defaultView = 'ALL' }: IApplicationDashboardComponentProps) => {
  const applicationsList = data?.data;

  const widgetsData: {
    totalApplications: number;
    totalBuildings: number;
    totalAmountRequested: number;
    totalProgramFunds: number;
    totalApprovedProjects: number;
    totalProgramFundsRemaining: number;
    totalValueOfAllProjects: number;
    blightedPropertiesEliminated: number;
    totalPropertiesReturnedToUse: number;
    totalHousingUnitsCreated: number;
    totalAffordableUnitsCreated: number;
    totalNewJobsCreated: number;
    statusSummary: { [key: string]: number };
    newJobsCreatedByClassification: { [key: string]: number };
  } = {
    totalApplications: 0,
    totalBuildings: 0,
    totalAmountRequested: 0,
    totalProgramFunds: 0,
    totalApprovedProjects: 0,
    totalProgramFundsRemaining: 0,
    totalValueOfAllProjects: 0,
    blightedPropertiesEliminated: 0,
    totalPropertiesReturnedToUse: 0,
    totalHousingUnitsCreated: 0,
    totalAffordableUnitsCreated: 0,
    totalNewJobsCreated: 0,
    statusSummary: {},
    newJobsCreatedByClassification: {},
  };

  applicationsList?.forEach((a: any) => {
    const { applicationData } = a;

    const section2 = applicationData?.step3?.section2 || [];

    //Total Application Widget
    widgetsData.totalApplications += 1;

    // Total Amount Requested
    widgetsData.totalAmountRequested += section2.reduce((acc: any, curr: any) => {
      return acc + (curr ? curr?.totalCost : 0);
    }, 0);

    //Status Summary
    widgetsData.statusSummary[a.status] = (widgetsData.statusSummary[a.status] ?? 0) + 1;

    // Total Program Funds
    // ! TODO : It will be fixed amount provided by the client
    // widgetsData['totalProgramFunds']
    const { willResultRhu, affordableHousing, createNewJob, ahCount, rhuCount, jobClassification } = applicationData?.step4?.section1 || {};
    const buildingCount = applicationData?.step1?.section2?.buildingCount || 0;

    if (a.status === 'APPROVED') {
      // Total Buildings
      widgetsData.totalBuildings += buildingCount ?? 0;

      // Total Approved Project
      widgetsData.totalApprovedProjects += 1;

      // Total Value Of All Projects
      widgetsData.totalValueOfAllProjects += section2.reduce((acc: any, curr: any) => {
        return acc + (curr ? curr?.totalCost : 0);
      }, 0);

      // Total Blighted Properties Eliminated
      widgetsData.blightedPropertiesEliminated += applicationData?.step4?.section3?.q3 === 'yes' ? 1 : 0;

      // Total Properties Returned To Use
      if (applicationData?.step4?.section3?.q1 === 'yes')
        widgetsData.totalPropertiesReturnedToUse += applicationData?.step1?.section2?.buildingCount;

      // Total Housing Units Created
      widgetsData.totalHousingUnitsCreated += willResultRhu === 'yes' ? rhuCount : 0;

      // Total Affordable Units Created
      widgetsData.totalAffordableUnitsCreated += affordableHousing === 'yes' ? ahCount : 0;

      // Total New Jobs Created
      widgetsData.totalNewJobsCreated +=
        createNewJob === 'yes'
          ? jobClassification.length > 0 &&
            jobClassification.reduce((acc: any, curr: any) => {
              return acc + curr?.noOfJobs;
            }, 0)
          : 0;

      // Total Program Funds Remaining
      const source = applicationData?.step3?.section2.find((f: any) => f?.source === 'Façade Program Assistance');
      const totalCost = source ? source?.totalCost : 0;
      widgetsData.totalProgramFundsRemaining += widgetsData.totalAmountRequested - totalCost;

      //New Job Created By Classification
      if (jobClassification.length > 0) {
        jobClassification?.forEach((job: any) => {
          if (job?.title) {
            widgetsData.newJobsCreatedByClassification[job?.title] =
              (widgetsData.newJobsCreatedByClassification[job?.title] ?? 0) + job?.noOfJobs;
          }
        });
      }
    }
  });
  const [viewStatus, setViewStatus] = useState<string>(defaultView);
  return (
    <div className='max-w-screen-3xl mx-auto'>
      <div className='font-semibold text-bold py-4 rounded-md space-x-2'>
        <span
          className={`${
            viewStatus === 'ALL' ? 'bg-primaryColor-normal' : 'bg-neutralColor-light hover:bg-primaryColor-normal'
          } text-white px-4 py-2 cursor-pointer`}
          onClick={() => setViewStatus('ALL')}
        >
          All Applications
        </span>
        <span
          className={`${
            viewStatus === 'APPROVED' ? 'bg-primaryColor-normal' : 'bg-neutralColor-light hover:bg-primaryColor-normal'
          } text-white px-4 py-2 cursor-pointer`}
          onClick={() => setViewStatus('APPROVED')}
        >
          Approved Applications
        </span>
      </div>

      <div className='my-4'>
        {/* <Card title='Project Location'>
            {false && (
              <div className='w-full flex justify-center items-center h-screen/2'>
                <div className='flex justify-center items-center gap-2 text-primaryColor-normal'>
                  <MapPinIcon className='h-8 w-8' />
                  <h1>No Projects</h1>
                </div>
                <p>There are no assigned projects to display.</p>
              </div>
            )}
            {true && (
              <div className='w-full grid grid-cols-6 h-screen/2'>
                <div className='col-span-6 w-full border-l p-5'>
                  <MapGoogle projectList={dashboardData?.project_location} />
                </div>
              </div>
            )}
          </Card> */}
      </div>
      {viewStatus === 'ALL' && <CHDOAllApplications data={widgetsData} />}
      {viewStatus === 'APPROVED' && <CHDOApprovedApplications data={widgetsData} />}
    </div>
  );
};
